// extracted by mini-css-extract-plugin
module.exports = {"table":"style-module_table_2Y67v","is-leaf":"style-module_is-leaf_aWSHi","pagination":"style-module_pagination_3pBaU"};